import { donateUrl } from '../searchConfig';

export function DonationCta() {
  return (
    <aside className="donation-cta" aria-label="Support GOT Connections">
      <div>
        <p className="cta-kicker">Support Our Mission</p>
        <p>
          Help GOT Connections fund education, outreach, and community programs that bring real resources to real people.
        </p>
      </div>
      <a href={donateUrl} target="_blank" rel="noreferrer">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 21s-7-4.4-9.2-9.1C1.1 8.2 3.3 5 6.7 5c2 0 3.3 1.1 4.1 2.2C11.6 6.1 13 5 15 5c3.4 0 5.6 3.2 3.9 6.9C19 16.6 12 21 12 21Z" />
        </svg>
        <span>Donate Now</span>
      </a>
    </aside>
  );
}
